export default "__VITE_ASSET__0kMVXEiD__ 640w, __VITE_ASSET__C8tspchg__ 971w";